<template>
  <div class="sr-cmt__cmt">
    <div class="d-flex">
      <!-- avatar -->
      <div class="d-flex align-items-start">
        <div class="sr__avater">
          <img :src="cmt.avatar_url">
        </div>
      </div>

      <div class="w-100">
        <div class="sr-cmt__meta">
          <!-- meta -->
          <div class="font-weight-bold">{{ cmt.name }}</div>
          <div class="px-1 sr-cmt__at">•</div>
          <div class="mr-2">{{ cmt.updated_at }}</div>

          <!-- destroy -->
          <div
            @click="destroyComment"
            v-if="!editing && !deleted && isOwned && !disabled"
          >
            <b-icon icon="trash2"></b-icon>
          </div>

          <!-- new comment badge -->
          <div
            class="sr__badge sr__badge--sq sr__badge--red"
            v-if="cmt.readed === false && !isOwned"
          >NEW</div>

          <!-- icon -->
          <div v-if="isCoin || isSilver" class="ml-1 mb-1">
            <img v-if="isCoin" alt="checkmark" src="@/assets/img/coin.png" class="checkmark-img-sty">
            <img v-if="isSilver" alt="checkmark" src="@/assets/img/silver.png" class="checkmark-img-sty" style="width:16px; height:16px;">
          </div>
        </div>

        <div v-show="!editing && !deleted">
          <!-- content -->
          <div class="sr-cmt__content mb-1">
            {{ cmt.content }}
          </div>

          <!-- edit -->
          <div
            class="d-flex align-items-center"
            v-if="!deleted && isOwned && !disabled"
          >
            <b-icon
              class="mr-2"
              icon="pencil-square"
              @click="editComment"
            ></b-icon>
          </div>
        </div>

        <!-- textarea for editing -->
        <div
          class="sr__comment-box"
          v-show="editing"
        >
          <textarea
            @input="autoTextareaHeight($event.target)"
            placeholder="請修改評論..."
            v-model="cmt.content"
            ref="commentItem"
          ></textarea>

          <div class="d-flex justify-content-end">
            <button
              class="sr__comment-action mr-1"
              :disabled="sending"
              @click="cancelEditComment"
            >取消</button>

            <button
              class="sr__comment-action sr__comment-action--submit"
              :disabled="sending"
              @click="updateComment"
            >{{ `送出${sending ? '中...' : ''}` }}</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Comment',
  props: {
    lineId: String,
    replyId: Number,
    orgCmt: Object,
    recordId: [String, Number],
    disabled: Boolean
  },
  data () {
    return {
      cmt: {},
      editing: false,
      deleted: false,
      sending: false,
      rawContent: ''
    }
  },
  watch: {
    orgCmt: {
      handler () {
        this.cmt = this.orgCmt
      },
      immediate: true
    }
  },
  computed: {
    isOwned () {
      return this.cmt.line_id === this.lineId
    },
    isCoin () {
      return this.isOwned && this.cmt.is_current_reward_point_comment
    },
    isSilver () {
      return this.isOwned && !this.isCoin && this.cmt.is_reward_point_comment
    }
  },
  methods: {
    apiUrl (action) {
      return `${this.$apiDoc.staffUrlV1}/${this.$store.state.userId}/${this.$apiDoc.apiGetService}/${this.recordId}/${this.apiAction(action)}`
    },
    apiAction (action) {
      var base = 'comment'

      if (this.replyId) {
        return `${action}_reply_${base}`
      }

      return `${action}_${base}`
    },
    editComment () {
      this.editing = !this.editing
      this.rawContent = this.cmt.content

      this.autoTextareaHeight(this.$refs.commentItem)
    },
    cancelEditComment () {
      var yes = confirm('確定取消?')
      if (yes) {
        this.cmt.content = this.rawContent
        this.editing = false
      }
    },
    async updateComment () {
      this.sending = true
      const options = {
        comment_id: this.cmt.id,
        comment: {
          content: this.cmt.content
        }
      }

      var r = false
      try {
        const resp = await this.$api.post(this.apiUrl('update'), options)
        var updatedComment = resp.comment

        this.cmt.updated_at = updatedComment.updated_at
        this.cmt.content = updatedComment.content

        this.rawContent = updatedComment.content
        this.editing = false

        r = true
      } catch (e) {
        console.error(e)
      }

      this.sending = false
      return r
    },
    async destroyComment () {
      if (this.cmt.is_reward_point_comment) {
        var cmtDate = new Date(this.cmt.created_date).toDateString()
        var today = new Date().toDateString()
        this.cmt.is_current_reward_point_comment = today === cmtDate

        console.log(cmtDate)
        console.log(today)
        console.log(this.cmt.is_current_reward_point_comment)

        if (!this.cmt.is_current_reward_point_comment) {
          var yes = confirm('若刪除將會取消之前獲得的積分，確定刪除評論?')
          if (!yes) {
            return
          }
        }
      }

      this.cmt.content = ''
      this.cmt.name = '評論刪除中...'
      this.deleted = true

      const options = {
        comment_id: this.cmt.id
      }

      var r = false
      try {
        await this.$api.post(this.apiUrl('destroy'), options)
        this.cmt.name = '評論已刪除'
        this.cmt.is_reward_point_comment = false
        this.cmt.is_current_reward_point_comment = false

        this.$emit('destroyComment')
        r = true
      } catch (e) {
        this.cmt.name = '刪除失敗'
        console.error(e)
      }

      return r
    },
    autoTextareaHeight (target) {
      this.$nextTick(() => {
        target.style.height = target.scrollHeight + 'px'
      })
    }
  }
}
</script>
